<template>
    <div>
        <router-link 
            v-for="(item,ind) in list" 
            :key='ind'
            class="movie-card-one"
            :to="{path:'/movieDetails'}"
        >
        <!-- :to="{path:'/movieDetails/'+ item.id}" -->
            <div class="left-img">
                <img :src="item.img"/>
            </div>
            <div class="center">
                <div class="title">{{item.title}}</div>
                <div class="score">评分：<span>{{item.score}}</span></div>
                <div class="director">导演：{{item.director}}</div>
                <div class="director star">主演：{{item.star}}</div>
            </div>
            <div class="movie-gradient right">购票</div>
        </router-link>
  </div>
</template>

<script>
export default {
    name:"MovieCard",
    data:function(){
        return {
        }
    },
    props:{
        list:{
          type: Array,
          default: () => []
        }
    }
}
</script>

<style scoped>
.movie-card-one{
    width:100%;
    height:2.4rem;
    box-sizing: border-box;
    padding:.2rem 1.3rem .2rem 0;
    display:flex;
    position:relative;
    border-bottom:.02rem solid #D2D2D2;
}
.left-img{
    width:1.5rem;
    height:2rem;
    margin-right:.2rem;
}
.left-img img{
    width:100%;
    height:100%;
    border-radius:.2rem;
}
.center{
    width:12em;
    height:100%;
    box-sizing: border-box;
    padding:.15rem 0;
    overflow: hidden;
}
.right{
    width:1.6rem;
    height:.6rem;
    color:white;
    font-size:.3rem;
    position:absolute;
    top:50%;
    right:0;
    transform: translate(0,-50%);
    border-radius:.5rem;
    text-align:center;
    line-height:.6rem;
}
.director{
    width:100%;
    color: #999999;
    font-size:.28rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.title{
    width:100%;
    color:#333333;
    font-size:.3rem;
    height:.5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.score{
    height:.45rem;
    color:#333333;
}
.score span{
    color:#FF0B46;
    font-size:.28rem;
}


</style>